import { render, staticRenderFns } from "./Reveal1.vue?vue&type=template&id=a8384626&scoped=true&"
import script from "./Reveal1.vue?vue&type=script&lang=js&"
export * from "./Reveal1.vue?vue&type=script&lang=js&"
import style0 from "./Reveal1.vue?vue&type=style&index=0&id=a8384626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8384626",
  null
  
)

export default component.exports